import * as React from 'react';

const AddWithInput = ({ n1, initialN2 = 0 }: { n1: number; initialN2: number }) => {
  const [n2, setN2] = React.useState(Number(initialN2));
  return (
    <div>
      {n1} + <input aria-label="n2" type="number" value={n2} onChange={(e) => setN2(Number(e.target.value))} /> ={' '}
      {Number(n1) + n2}
    </div>
  );
};

export { AddWithInput };
